import React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import SelenseAuthGate from "./components/SelenseAuthGate";
import SelenseHealthMemory from "./components/SelenseHealthMemory";
import SelenseLanding from "./components/SelenseLanding";
import SelensePrivacyPolicy from "./pages/SelensePrivacyPolicy";

function LandingRoute() {
  const navigate = useNavigate();

  return (
    <SelenseLanding
      onGetStarted={() => navigate("/auth")}
      onSeeHowItWorks={() => {
        document
          .getElementById("selense-demo")
          ?.scrollIntoView({ behavior: "smooth" });
      }}
    />
  );
}

function AuthRoute() {
  return (
    <SelenseAuthGate>
      <SelenseHealthMemory />
    </SelenseAuthGate>
  );
}

function SelenseApp() {
  return (
    <ChakraProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingRoute />} />
          <Route path="/auth" element={<AuthRoute />} />
          <Route path="/privacy-policy" element={<SelensePrivacyPolicy />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ChakraProvider>
  );
}

export default SelenseApp;